import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitConfigurationSubmissionData } from './variable-benefit-configuration-submission-data';

export class VariableBenefitConfigurationSubmission implements Deserializable {
  public new!: VariableBenefitConfigurationSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.new) {
      this.new = Deserialize.instanceOf(VariableBenefitConfigurationSubmissionData, this.new);
    }
  }
}
